import type { CityItem } from '../types/api'
import { authFetch } from './apiClient'

const BASE = '/newspaper/api/v1'

export async function fetchCities(lang?: string): Promise<CityItem[]> {
  const params = lang ? `?lang=${encodeURIComponent(lang)}` : ''
  const res = await authFetch(`${BASE}/cities/${params}`)
  if (!res.ok) throw new Error(`cities API error: ${res.status}`)
  const data = await res.json() as { cities: CityItem[] }
  return data.cities
}
